import { render, staticRenderFns } from "./ReferenceNumber.vue?vue&type=template&id=966fdbe0&"
import script from "./ReferenceNumber.vue?vue&type=script&lang=js&"
export * from "./ReferenceNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports